var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { DangerZoneItem } from './danger-zone-item';
import { RowLayout } from '../row-layout';
import { Text } from '../text';
export var DangerZone = React.forwardRef(function (props, ref) {
    var className = props.className, _a = props.title, title = _a === void 0 ? 'Danger Zone' : _a, _b = props.items, items = _b === void 0 ? [] : _b, rootProps = __rest(props, ["className", "title", "items"]);
    return (React.createElement(RowLayout, __assign({ as: "section", className: className, ref: ref }, rootProps, { gutter: 2 }),
        React.createElement(Text, { variant: "h6", component: "h2" }, title),
        React.createElement(RowLayout, { gutter: 1, as: "ul" }, items.map(function (item, i) { return (React.createElement(DangerZoneItem, __assign({ key: i }, item))); }))));
});
